import React from 'react'

import { AnalyticEventFunction, AnalyticPageviewFunction } from '../../core'

export const useCombineEvents = (events: AnalyticEventFunction[], store: any) => {
  const { session } = store

  const storeEvents = Object.values(store).reduce((acc: AnalyticEventFunction[], curr: any) => {
    if (session && curr?.onAnalyticEvent && typeof curr?.onAnalyticEvent === 'function') {
      return [...acc, curr.onAnalyticEvent]
    }

    return acc
  }, [])
  const eventFunctions = [...events, ...storeEvents]

  return React.useMemo(() => {
    return (event: string) => {
      eventFunctions.forEach((e) => {
        if (!session) {
          e(event)
        } else {
          e(event, session)
        }
      })
    }
  }, [events, session])
}

export const useCombinePageviews = (pages: AnalyticPageviewFunction[], store: any) => {
  const { session } = store

  const storeEvents = Object.values(store).reduce((acc: AnalyticPageviewFunction[], curr: any) => {
    if (session && curr?.onAnalyticPageView && typeof curr?.onAnalyticPageView === 'function') {
      return [...acc, curr.onAnalyticPageView]
    }

    return acc
  }, [])
  const eventFunctions = [...pages, ...storeEvents]

  return React.useMemo(() => {
    return (event: string) => {
      eventFunctions.forEach((e) => {
        if (!session) {
          e(event)
        } else {
          e(event, session)
        }
      })
    }
  }, [pages, session])
}
